import React from 'react';
import { Carousel } from 'react-bootstrap';
import './Portfolio.css';

const caseStudies = [
  {
    title: 'Video Corporativo - Armonízate 🎥',
    testimonial: 'El video superó nuestras expectativas, capturó perfectamente nuestra esencia. ¡Impactante!',
    placeholderClass: 'portfolio-image-1'
  },
  {
    title: 'Sitio Web - HOLD SL 🌐',
    testimonial: 'Un diseño web impecable y funcional. El posicionamiento SEO nos ha traído muchos clientes nuevos.',
    placeholderClass: 'portfolio-image-2'
  },
  {
    title: 'Fotografía de Bodas 📸',
    testimonial: 'Las fotos son un tesoro para toda la vida. Profesionalismo y una calidad artística increíble.',
    placeholderClass: 'portfolio-image-3'
  }
];

const Portfolio = () => {
  return (
    <section id="portfolio" className="portfolio-section-slider py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Nuestro Portafolio</h2>
          <p className="lead text-muted">Explora algunos de nuestros proyectos más destacados y el impacto que generamos.</p>
        </div>
        <Carousel>
          {caseStudies.map((study, index) => (
            <Carousel.Item key={index} className="portfolio-carousel-item">
              <div className={`d-block w-100 portfolio-image-placeholder ${study.placeholderClass}`}></div>
              <Carousel.Caption className="portfolio-carousel-caption">
                <h5 className="fw-bold">{study.title}</h5>
                <p className="fst-italic d-none d-sm-block">{study.testimonial}</p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default Portfolio;
